"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var DetailDataSingleLabel_1 = __importDefault(require("../contract_form/DetailDataSingleLabel"));
var date_parser_1 = __importDefault(require("../../../common/src/utils/date/date_parser"));
var SalesForceButtonArea_1 = __importDefault(require("./SalesForceButtonArea"));
var DatePickerWrapper_1 = __importDefault(require("../datepicker/DatePickerWrapper"));
var value_checker_1 = __importDefault(require("../../../common/src/utils/validation/value_checker"));
var ReflectType_1 = require("../../../common/src/types/sales_force/ReflectType");
var MoveSalesForceButton_1 = __importDefault(require("./MoveSalesForceButton"));
var SimpleDialog_1 = __importDefault(require("../globals/SimpleDialog"));
var PriceBookSelect_1 = __importDefault(require("./PriceBookSelect"));
var ProductSelect_1 = __importDefault(require("./ProductSelect"));
var FreePeriod_1 = __importDefault(require("./FreePeriod"));
var object_utils_1 = __importDefault(require("../../../common/src/utils/sales_force/object_utils"));
var contract_finish_1 = require("../../utils/mail/template/contract_finish");
var price_book_utils_1 = __importDefault(require("../../../common/src/utils/sales_force/price_book_utils"));
var OpportunityOralCare = /** @class */ (function (_super) {
    __extends(OpportunityOralCare, _super);
    function OpportunityOralCare() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {};
        _this.showAlertDialog = false;
        _this.showConfirmDialog = false;
        _this.alertMessage = '';
        _this.confirmMessage = '';
        _this.salesForceInfo = {
            torihikisakiId: '',
            opportunityId: '',
            oralCareContractState: '',
            oralCareRequestStartDate: null,
            oralCareContractEdate: null,
            oralCareItPeriod: '',
            oralCcarePrice: '',
            oralCareBunkatuFlg: '',
            oralCareItFlg: '',
            oralCareTokubetuFlg: '',
            oralCareTokubetuDetail: '',
            useOralCareFreePeriod: [],
            opportunityOralCareId: '',
            opportunityOralCareName: '',
            oralCareContractStartDate: null,
            oralCarePriceBook2Id: '',
            oralCareProductId: '',
            opportunityOralCareItemId: '',
            oralCarePriceBook2Name: '',
            oralCarePriceBook2Description: '',
            oralCarePriceDefault: '',
            oralCareProductName: '',
            oralCareFreePriceBook2Id: '',
            oralCareFreePriceBook2Name: '',
            oralCareFreeProductId: '',
            oralCareFreeProductName: '',
            oralCareFreePeriod: '',
            oralCarePriceBookMonth: '',
            freeOpportunityOralCareId: '',
            freeOpportunityOralCareItemId: '',
            freeOpportunityOralCareName: '',
            freeOralCareContractStartDate: '',
            oralCarePriceBookData: [],
            oralCareProductPlanName: '',
            oralCareCancelFlag: '',
        };
        _this.useOralCareFreePeriod = '';
        _this.oralCarePrice = '';
        return _this;
    }
    OpportunityOralCare.prototype.getPlanName = function () {
        return contract_finish_1.ContractCompleteMailTemplate.getOralCarePlanName(this.form, this.salesForceInfo);
    };
    OpportunityOralCare.prototype.isCancelFlgDisable = function () {
        return price_book_utils_1.default.isNotStandardPriceBook(this.salesForceInfo.oralCareFreePriceBook2Id);
    };
    OpportunityOralCare.prototype.periodChange = function () {
        var sdate = this.form.applyInfoOralCareSstartDate;
        // 無料期間有り
        if (this.salesForceInfo.useOralCareFreePeriod && this.salesForceInfo.useOralCareFreePeriod.length) {
            this.salesForceInfo.freeOralCareContractStartDate = sdate;
            this.salesForceInfo.oralCareContractStartDate = object_utils_1.default.getSdateNextContract(sdate, this.salesForceInfo.oralCareFreePeriod);
        }
        else {
            this.salesForceInfo.oralCareContractStartDate = sdate;
        }
        this.salesForceInfo.oralCareRequestStartDate = object_utils_1.default.getSdateNextContract(this.salesForceInfo.oralCareContractStartDate, '1');
        if (this.salesForceInfo.oralCarePriceBookMonth === '1') {
            this.salesForceInfo.oralCareContractEdate = '';
        }
        else {
            this.salesForceInfo.oralCareContractEdate = object_utils_1.default.getEdateFromSdate(this.salesForceInfo.oralCareContractStartDate, this.salesForceInfo.oralCarePriceBookMonth);
        }
    };
    OpportunityOralCare.prototype.freeProductChange = function (newProductInfo) {
        this.salesForceInfo.oralCareFreeProductName = newProductInfo['name'];
    };
    OpportunityOralCare.prototype.freePriceBookChange = function (newBookInfo) {
        this.salesForceInfo.oralCareFreePriceBook2Name = newBookInfo['name'];
        if (newBookInfo['cancelFlg']) {
            this.salesForceInfo.oralCareCancelFlag = 'true';
        }
        else {
            this.salesForceInfo.oralCareCancelFlag = '';
        }
    };
    OpportunityOralCare.prototype.oralCarePriceChange = function (newPrice) {
        this.oralCarePrice = String(newPrice);
        this.salesForceInfo.oralCcarePrice = this.oralCarePrice;
    };
    OpportunityOralCare.prototype.entryChange = function (newProductItems) {
        this.salesForceInfo.oralCarePriceBookData = newProductItems;
    };
    OpportunityOralCare.prototype.productChange = function (newProductInfo) {
        this.salesForceInfo.oralCareProductName = newProductInfo['name'];
        this.salesForceInfo.oralCareProductPlanName = newProductInfo['planName'];
        this.salesForceInfo.oralCarePriceBookMonth = newProductInfo['month'];
        this.periodChange();
    };
    OpportunityOralCare.prototype.onUseOralCareFreePeriodChange = function (newVal) {
        if (newVal) {
            this.salesForceInfo.useOralCareFreePeriod = [0];
        }
        else {
            this.salesForceInfo.useOralCareFreePeriod = [];
        }
        this.periodChange();
    };
    OpportunityOralCare.prototype.getTranslation = function (key) {
        return this.$t(key);
    };
    OpportunityOralCare.prototype.refs = function () {
        return this.$refs;
    };
    OpportunityOralCare.prototype.parseDate = function (dateStr) {
        return date_parser_1.default.toJapaneseDateStr(dateStr);
    };
    OpportunityOralCare.prototype.reCorrect = function () {
        this.$emit('re-correct');
    };
    OpportunityOralCare.prototype.getSalesForcePeriod = function () {
        return object_utils_1.default.getSalesForcePeriod(this.form.applyInfoOralCarePeriod);
    };
    OpportunityOralCare.prototype.mounted = function () {
        this.initDataChange();
        this.initSalesForceDataChange();
    };
    OpportunityOralCare.prototype.salesForceAutoComplete = function () {
        if (value_checker_1.default.isBlank(this.salesForceInfo.oralCareContractStartDate)) {
            this.salesForceInfo.oralCareContractStartDate = this.form['applyInfoOralCareSstartDate'];
        }
        if (value_checker_1.default.isBlank(this.salesForceInfo.opportunityOralCareName)) {
            this.salesForceInfo.opportunityOralCareName = this.form.officeInfoOfficeName + "_" + date_parser_1.default.toString(new Date()) + "_\u53E3\u8154";
        }
        if (value_checker_1.default.isBlank(this.salesForceInfo.freeOpportunityOralCareName)) {
            this.salesForceInfo.freeOpportunityOralCareName = this.form.officeInfoOfficeName + "_" + date_parser_1.default.toString(new Date()) + "_\u53E3\u8154_\u7121\u6599";
        }
        if (price_book_utils_1.default.hasFree(this.salesForceInfo.useOralCareFreePeriod)) {
            this.useOralCareFreePeriod = 'true';
        }
        this.periodChange();
    };
    OpportunityOralCare.prototype.initDataChange = function () {
        this.form = this.initData;
        this.salesForceAutoComplete();
    };
    OpportunityOralCare.prototype.initSalesForceDataChange = function () {
        this.salesForceInfo = this.initSalesForceData;
        this.salesForceAutoComplete();
    };
    OpportunityOralCare.prototype.submit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var self_, errorMessage;
            return __generator(this, function (_a) {
                self_ = this;
                event.preventDefault();
                if (value_checker_1.default.isBlank(self_.salesForceInfo.torihikisakiId)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_torihikisaki_id').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(self_.salesForceInfo.oralCarePriceBook2Id)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_pricebook_id').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(String(self_.salesForceInfo.oralCareProductId))) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_product_id').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(String(self_.salesForceInfo.oralCcarePrice))) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_price').toString();
                    return [2 /*return*/];
                }
                // 無料期間ありの場合。
                if (value_checker_1.default.isPresent(this.useOralCareFreePeriod)) {
                    if (value_checker_1.default.isBlank(self_.salesForceInfo.oralCareFreePriceBook2Id)) {
                        this.showAlertDialog = true;
                        this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_free_pricebook_id').toString();
                        return [2 /*return*/];
                    }
                    if (value_checker_1.default.isBlank(String(self_.salesForceInfo.oralCareFreeProductId))) {
                        this.showAlertDialog = true;
                        this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_free_product_id').toString();
                        return [2 /*return*/];
                    }
                    if (value_checker_1.default.isBlank(String(self_.salesForceInfo.oralCareFreePeriod))) {
                        this.showAlertDialog = true;
                        this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_free_product_period').toString();
                        return [2 /*return*/];
                    }
                }
                if (this.isPriceDifferent() && this.isTokubetuBlank()) {
                    errorMessage = "<div class=\"col\">" +
                        this.$t('view.sales_force.reflect.msg.price_error') +
                        ("<br>\u6A19\u6E96\u4FA1\u683C: <strong>" + this.oralCarePrice + "</strong><br>") +
                        ("\u8CA9\u58F2\u4FA1\u683C: <strong>" + this.salesForceInfo.oralCcarePrice + "</strong><br>");
                    this.showAlertDialog = true;
                    this.alertMessage = errorMessage;
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isPresent(self_.salesForceInfo.oralCareBunkatuFlg)
                    && this.isTokubetuBlank()) {
                    this.showAlertDialog = true;
                    this.alertMessage = String(this.$t('view.sales_force.reflect.msg.bunkatu_error'));
                    return [2 /*return*/];
                }
                if (price_book_utils_1.default.isAbnormal(self_.salesForceInfo.oralCarePriceBook2Id, self_.salesForceInfo.useOralCareFreePeriod) &&
                    this.isTokubetuBlank()) {
                    this.showAlertDialog = true;
                    this.alertMessage = String(this.$t('view.sales_force.reflect.msg.tokubetu_error'));
                    console.log('Called..');
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isPresent(self_.salesForceInfo.opportunityOralCareId) ||
                    value_checker_1.default.isPresent(self_.salesForceInfo.freeOpportunityOralCareId)) {
                    this.confirmMessage = '商談・商談商品オブジェクト（口腔機能）を<strong>更新</strong>します。よろしいですか？';
                }
                else {
                    this.confirmMessage = '商談・商談商品オブジェクト（口腔機能）を<strong>新規に追加</strong>します。よろしいですか？';
                }
                this.showConfirmDialog = true;
                return [2 /*return*/];
            });
        });
    };
    OpportunityOralCare.prototype.dialogClose = function () {
        this.showConfirmDialog = false;
        this.showAlertDialog = false;
    };
    OpportunityOralCare.prototype.reflect = function () {
        var self_ = this;
        self_.dialogClose();
        this.$emit('reflect', this.getAjaxInfo());
    };
    OpportunityOralCare.prototype.getPriceErrorMsg = function () {
        if (this.isPriceDifferent()) {
            return this.$t('view.sales_force.reflect.msg.price_warning');
        }
        return '';
    };
    OpportunityOralCare.prototype.isPriceDifferent = function () {
        return String(this.oralCarePrice) !== String(this.salesForceInfo.oralCcarePrice);
    };
    OpportunityOralCare.prototype.isTokubetuBlank = function () {
        return value_checker_1.default.isBlank(this.salesForceInfo.oralCareTokubetuDetail);
    };
    OpportunityOralCare.prototype.getAjaxInfo = function () {
        // カラム追加した項目は、NullCareをしないと、trim()でエラー
        if (!this.salesForceInfo.opportunityOralCareId) {
            this.salesForceInfo.opportunityOralCareId = '';
        }
        if (!this.salesForceInfo.opportunityOralCareItemId) {
            this.salesForceInfo.opportunityOralCareItemId = '';
        }
        if (!this.salesForceInfo.freeOpportunityOralCareId) {
            this.salesForceInfo.freeOpportunityOralCareId = '';
        }
        if (!this.salesForceInfo.freeOpportunityOralCareItemId) {
            this.salesForceInfo.freeOpportunityOralCareItemId = '';
        }
        var reflectType = [ReflectType_1.SalesForceReflectType.OPPORTUNITY_ORAL_CARE, ReflectType_1.SalesForceReflectType.OPPORTUNITY_ITEM_ORAL_CARE];
        if (value_checker_1.default.isPresent(this.useOralCareFreePeriod)) {
            reflectType.unshift(ReflectType_1.SalesForceReflectType.OPPORTUNITY_ITEM_ORAL_CARE_FREE);
            reflectType.unshift(ReflectType_1.SalesForceReflectType.OPPORTUNITY_ORAL_CARE_FREE);
        }
        return {
            salesForceInfo: {
                torihikisakiId: this.salesForceInfo.torihikisakiId.trim(),
                oralCareContractState: this.salesForceInfo.oralCareContractState,
                oralCareRequestStartDate: this.salesForceInfo.oralCareRequestStartDate,
                oralCareContractEdate: this.salesForceInfo.oralCareContractEdate,
                oralCareItPeriod: this.salesForceInfo.oralCareItPeriod,
                oralCcarePrice: this.salesForceInfo.oralCcarePrice,
                oralCareBunkatuFlg: this.salesForceInfo.oralCareBunkatuFlg,
                oralCareItFlg: this.salesForceInfo.oralCareItFlg,
                oralCareTokubetuFlg: this.salesForceInfo.oralCareTokubetuFlg,
                oralCareTokubetuDetail: this.salesForceInfo.oralCareTokubetuDetail,
                useOralCareFreePeriod: this.salesForceInfo.useOralCareFreePeriod,
                opportunityOralCareId: this.salesForceInfo.opportunityOralCareId.trim(),
                opportunityOralCareName: this.salesForceInfo.opportunityOralCareName,
                oralCareContractStartDate: this.salesForceInfo.oralCareContractStartDate,
                oralCarePriceBook2Id: this.salesForceInfo.oralCarePriceBook2Id,
                oralCareProductId: this.salesForceInfo.oralCareProductId,
                opportunityOralCareItemId: this.salesForceInfo.opportunityOralCareItemId.trim(),
                oralCarePriceBookMonth: this.salesForceInfo.oralCarePriceBookMonth,
                freeOpportunityOralCareId: this.salesForceInfo.freeOpportunityOralCareId.trim(),
                freeOpportunityOralCareItemId: this.salesForceInfo.freeOpportunityOralCareItemId.trim(),
                freeOpportunityOralCareName: this.salesForceInfo.freeOpportunityOralCareName,
                freeOralCareContractStartDate: this.salesForceInfo.freeOralCareContractStartDate,
                oralCarePriceBookData: this.salesForceInfo.oralCarePriceBookData,
                oralCareProductPlanName: this.salesForceInfo.oralCareProductPlanName,
                oralCareCancelFlag: this.salesForceInfo.oralCareCancelFlag
            },
            reflectType: reflectType,
            fetchTypes: [ReflectType_1.SalesForceReflectType.OPPORTUNITY_ORAL_CARE, ReflectType_1.SalesForceReflectType.TORIHIKISAKI]
        };
    };
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], OpportunityOralCare.prototype, "initData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], OpportunityOralCare.prototype, "initSalesForceData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({
            default: function () {
            }
        })
    ], OpportunityOralCare.prototype, "fetchSalesForceInfo", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: [] })
    ], OpportunityOralCare.prototype, "priceBookData", void 0);
    __decorate([
        vue_property_decorator_1.Watch('useOralCareFreePeriod')
    ], OpportunityOralCare.prototype, "onUseOralCareFreePeriodChange", null);
    __decorate([
        vue_property_decorator_1.Watch('initData')
    ], OpportunityOralCare.prototype, "initDataChange", null);
    __decorate([
        vue_property_decorator_1.Watch('initSalesForceData')
    ], OpportunityOralCare.prototype, "initSalesForceDataChange", null);
    OpportunityOralCare = __decorate([
        vue_property_decorator_1.Component({
            components: {
                FreePeriod: FreePeriod_1.default,
                ProductSelect: ProductSelect_1.default,
                PriceBookSelect: PriceBookSelect_1.default,
                SimpleDialog: SimpleDialog_1.default,
                MoveSalesForceButton: MoveSalesForceButton_1.default,
                DatePickerWrapper: DatePickerWrapper_1.default,
                SalesForceButtonArea: SalesForceButtonArea_1.default,
                DetailDataSingleLabel: DetailDataSingleLabel_1.default
            }
        })
    ], OpportunityOralCare);
    return OpportunityOralCare;
}(vue_property_decorator_1.Vue));
exports.default = OpportunityOralCare;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sales_force/OpportunityOralCare.vue
// module id = oJBu
// module chunks = 1